import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/apiConfig';
import { Workflow } from './workflowTypes';

const fetchWorkflows = async (): Promise<Workflow[]> => {
  const response = await apiClient.get<Workflow[]>(`/csb/workflows`);
  return response.data;
};

export const useGetWorkflows = () => {
  return useQuery<Workflow[], Error>({
    queryFn: fetchWorkflows,
    queryKey: ['workflows'],
  });
};
